// 51天兔座、52天琴座、53巨爵座、54天鸽座、55狐狸座、56小熊座、57望远镜座、58时钟座、59绘架座、60南鱼座
// 61水蛇座、62唧筒座、63天坛座、64小狮座、65罗盘座、66显微镜座、67天燕座、68蝎虎座、69海豚座、70乌鸦座
// 71小犬座、72剑鱼座、73北冕座、74矩尺座、75山案座、76飞鱼座、77苍蝇座、78三角座、79蝘蜓座、80南冕座
// 81雕具座、82网罟座、83南三角座、84盾牌座、85圆规座、86天箭座、87小马座、88南十字座
// 星座图标translateX、Y、Z，rotateX、Y、Z
// 360°角=2π弧度，1弧度约为57.3°。π/2=1.57；2π/3=2.09；
const constelsIconArgs = {
  '3': [
    { name: 'translateY', value: 2000 },
    { name: 'rotateZ', value: Math.PI },
    { name: 'rotateY', value: Math.PI / 5 }
  ],
  '8': [
    { name: 'translateX', value: -600 },
    { name: 'translateZ', value: 800 },
    { name: 'rotateX', value: -Math.PI / 3 * 0.9 },
    { name: 'rotateZ', value: Math.PI * 0.9 },
  ],
  '11': [
    { name: 'translateY', value: 1000 },
    { name: 'translateZ', value: -300 },
    { name: 'rotateY', value: -Math.PI / 2 },
    { name: 'rotateZ', value: -Math.PI / 3 * 2 },
  ],
  '12': [
    { name: 'translateZ', value: 1400 },
    { name: 'translateY', value: -1600 },
    { name: 'translateZ', value: -600 },
    { name: 'rotateX', value: Math.PI },
    { name: 'rotateY', value: -Math.PI / 2 },
    { name: 'rotateZ', value: Math.PI / 2 - 0.3 },
  ],
  '13': [
    { name: 'translateY', value: -400 },
    { name: 'rotateX', value: -Math.PI / 4 * 3 + 0.5 },
    { name: 'rotateY', value: 1.6 },
    { name: 'rotateZ', value: Math.PI },
  ],
  '14': [
    { name: 'translateY', value: 900 },
    { name: 'translateX', value: -400 },
    { name: 'rotateY', value: -Math.PI / 6 },
    { name: 'rotateX', value: -Math.PI },
    { name: 'rotateZ', value: -0.7 }
  ],
  '15': [
    { name: 'translateZ', value: 1000 },
    { name: 'rotateY', value: Math.PI / 2 },
    { name: 'rotateZ', value: Math.PI },
  ],
  '17': [
    { name: 'translateX', value: -900 },
    { name: 'translateZ', value: -900 },
    { name: 'translateY', value: -600 },
    { name: 'rotateX', value: Math.PI / 2 },
    { name: 'rotateY', value: -Math.PI / 3 + 0.5 },
  ],
  '18': [
    { name: 'translateZ', value: 800 },
    { name: 'translateY', value: -200 },
    { name: 'rotateY', value: Math.PI / 2 - 0.4 },
    { name: 'rotateX', value: Math.PI },
    { name: 'rotateZ', value: -Math.PI / 5 * 3 },
  ],
  '19': [
    { name: 'translateY', value: 1600 },
    { name: 'rotateX', value: Math.PI },
  ],
  '21': [
    { name: 'translateX', value: 1200 },
    { name: 'translateZ', value: 1600 },
    { name: 'rotateX', value: -Math.PI / 2 },
    { name: 'rotateZ', value: Math.PI + 0.5 },
  ],
  '24': [
    { name: 'translateY', value: 1000 },
    { name: 'rotateZ', value: Math.PI / 3 * 2 - 0.2 },
  ],
  '25': [
    { name: 'translateZ', value: 600 },
    { name: 'rotateY', value: Math.PI / 6 },
    { name: 'rotateZ', value: Math.PI / 3 },
  ],
  '27': [
    { name: 'translateZ', value: 2000 },
    { name: 'rotateX', value: -Math.PI / 4 },
    { name: 'rotateZ', value: -Math.PI / 5 },
  ],
  '28': [
    { name: 'rotateX', value: Math.PI / 2 },
    { name: 'rotateZ', value: -Math.PI / 2 + 0.2 },
  ],
  '29': [
    { name: 'rotateX', value: Math.PI / 3 },
  ],
  '30': [
    { name: 'translateZ', value: -1200 },
    { name: 'rotateY', value: Math.PI },
    { name: 'rotateZ', value: -Math.PI + 0.5 },
  ],
  '33': [
    { name: 'translateX', value: 600 },
    { name: 'rotateZ', value: Math.PI / 3 * 1.2 },
    { name: 'rotateY', value: Math.PI },
  ],
  '34': [
    { name: 'rotateX', value: -Math.PI / 4 },
  ],
  '35': [
    { name: 'translateY', value: -2000 },
    { name: 'translateX', value: -1000 },
    { name: 'translateZ', value: 1000 },
    { name: 'rotateZ', value: -Math.PI / 8 },
    { name: 'rotateY', value: Math.PI / 3 },
  ],
  '36': [
    { name: 'translateX', value: -1600 },
    { name: 'translateY', value: 600 },
    { name: 'translateZ', value: 900 },
    { name: 'rotateX', value: Math.PI / 12 },
    { name: 'rotateZ', value: Math.PI / 4 },
  ],
  '38': [
    { name: 'translateY', value: 1000 },
    { name: 'translateZ', value: -800 },
    { name: 'rotateY', value: Math.PI / 2 + 0.2 },
    { name: 'rotateZ', value: Math.PI / 12 },
  ],
  '44': [],
  '45': [
    { name: 'translateY', value: -700 },
    { name: 'rotateZ', value: -Math.PI / 2 },
  ],
  '46': [
    { name: 'translateX', value: -500 },
    { name: 'rotateY', value: Math.PI / 4 },
    { name: 'rotateX', value: -Math.PI / 8 },
    { name: 'rotateZ', value: -Math.PI / 6 * 5 },
  ],
  '47': [
    { name: 'translateZ', value: 800 },
    { name: 'translateY', value: -300 },
    { name: 'rotateY', value: Math.PI / 2 },
    { name: 'rotateX', value: Math.PI / 6 },
    { name: 'rotateZ', value: -Math.PI / 3 },
  ],
  '50': [
    { name: 'translateX', value: -800 },
    { name: 'translateY', value: -300 },
    { name: 'rotateZ', value: Math.PI / 2 }
  ],
  '51': [
    { name: 'translateX', value: -200 },
    { name: 'rotateX', value: Math.PI / 2 }
  ],
  '52': [
    { name: 'translateX', value: 200 },
    { name: 'translateY', value: -400 },
    { name: 'rotateX', value: Math.PI / 6 },
    { name: 'rotateY', value: -Math.PI / 8 },
    { name: 'rotateZ', value: Math.PI / 6 },
  ],
  '53': [
    { name: 'translateX', value: -600 },
    { name: 'rotateY', value: Math.PI / 6 },
    { name: 'rotateZ', value: -Math.PI / 8 },
  ],
  '54': [
    { name: 'translateX', value: -700 },
    { name: 'rotateX', value: Math.PI / 8 },
  ],
  '55': [
    { name: 'translateZ', value: 600 },
    { name: 'translateY', value: -500 },
    { name: 'rotateX', value: Math.PI / 4 },
  ],
  '56': [
    { name: 'translateX', value: -200 },
    { name: 'translateY', value: 300 },
    { name: 'rotateY', value: Math.PI },
  ],
  '57': [
    { name: 'rotateX', value: -Math.PI / 8 },
  ],
  '58': [
    { name: 'translateY', value: 2000 },
    { name: 'rotateY', value: -Math.PI / 4 },
  ],
  '59': [
    { name: 'translateX', value: -200 },
    { name: 'rotateX', value: Math.PI / 8 },
    { name: 'rotateZ', value: -Math.PI / 4 },
  ],
  '60': [
    { name: 'translateZ', value: 400 },
    { name: 'translateY', value: -300 },
    { name: 'rotateY', value: -Math.PI / 6 },
    { name: 'rotateZ', value: -Math.PI / 3 * 1.4 },
  ],
  '61': [
    { name: 'translateY', value: -300 },
    { name: 'rotateZ', value: -Math.PI / 4 },
  ],
  '62': [
    { name: 'translateX', value: 600 },
    { name: 'rotateY', value: Math.PI / 4 },
  ],
  '63': [
    { name: 'rotateX', value: -Math.PI / 8 },
  ],
  '64': [
    { name: 'rotateY', value: -Math.PI / 6 * 2 },
    { name: 'rotateZ', value: -Math.PI / 6 },
  ],
  '65': [
    { name: 'rotateY', value: Math.PI / 4 },
    { name: 'rotateX', value: Math.PI / 10 },
  ],
  '66': [
    { name: 'translateY', value: -600 },
    { name: 'rotateY', value: -Math.PI / 4 },
    { name: 'rotateX', value: -Math.PI / 5 - Math.PI },
    { name: 'rotateZ', value: -Math.PI / 2 },
  ],
  '67': [
    { name: 'rotateX', value: -Math.PI / 9 },
    { name: 'rotateZ', value: Math.PI / 4 },
  ],
  '68': [
    { name: 'translateX', value: 500 },
    { name: 'translateY', value: -200 },
    { name: 'rotateY', value: Math.PI / 9 },
    { name: 'rotateX', value: Math.PI / 4 },
  ],
  '69': [
    { name: 'translateX', value: 300 },
    { name: 'rotateY', value: Math.PI / 4 },
    { name: 'rotateX', value: Math.PI / 4 + Math.PI },
    { name: 'rotateZ', value: Math.PI / 3 * 2 },
  ],
  '70': [
    { name: 'translateY', value: -500 },
    { name: 'translateX', value: -400 },
    { name: 'rotateY', value: Math.PI / 3 },
  ],
  '71': [
    { name: 'translateY', value: -800 },
    { name: 'translateZ', value: -400 },
    { name: 'rotateX', value: Math.PI / 2 },
    { name: 'rotateZ', value: -Math.PI / 4 * 3 },
  ],
  '72': [
    { name: 'translateX', value: 800 },
    { name: 'translateY', value: 200 },
    { name: 'rotateY', value: Math.PI},
  ],
  '73': [
    { name: 'translateZ', value: 500 },
    { name: 'translateY', value: -400 },
    { name: 'rotateZ', value: -Math.PI / 2 },
    { name: 'rotateX', value: Math.PI / 4},
  ],
  '74': [
    { name: 'rotateZ', value: -Math.PI / 6 },
    { name: 'rotateX', value: -Math.PI / 6 },
  ],
  '75': [
    { name: 'translateY', value: 300 },
    { name: 'translateX', value: 100 },
    { name: 'rotateZ', value: -Math.PI * 0.9 }
  ],
  '76': [
    { name: 'translateY', value: 200 },
    { name: 'rotateZ', value: -Math.PI / 3 * 2 }
  ],
  '77': [
    { name: 'translateX', value: 100 },
    { name: 'rotateZ', value: -Math.PI / 3 * 2 }
  ],
  '78': [
    { name: 'translateX', value: -400 },
    { name: 'rotateZ', value: Math.PI / 4 * 1.2 }
  ],
  '79': [
    { name: 'translateX', value: 300 },
    { name: 'rotateZ', value: Math.PI / 6 }
  ],
  '80': [
    { name: 'translateY', value: 400 },
    { name: 'translateX', value: -200 },
    { name: 'rotateX', value: -Math.PI / 5 },
    { name: 'rotateZ', value: -Math.PI / 10 }
  ],
  '81': [
    { name: 'translateY', value: 600 },
    { name: 'rotateZ', value: -Math.PI / 4 },
  ],
  '82': [],
  '83': [
    { name: 'translateY', value: -200 },
    { name: 'translateZ', value: -400 },
    { name: 'rotateZ', value: Math.PI / 6 },
  ],
  '84': [
    { name: 'translateZ', value: -900 },
    { name: 'rotateX', value: -Math.PI / 2 },
  ],
  '85': [
    { name: 'translateY', value: -400 },
    { name: 'rotateX', value: -Math.PI / 6 },
  ],
  '86': [
    { name: 'rotateZ', value: -Math.PI / 2 },
    { name: 'rotateY', value: Math.PI / 6 },
  ],
  '87': [
    { name: 'rotateY', value: -Math.PI / 6 * 4 },
    { name: 'rotateZ', value: -Math.PI / 3 },
    { name: 'rotateX', value: -Math.PI / 4 },
  ],
  '88': [
    { name: 'translateX', value: 200 },
    { name: 'translateY', value: -400 },
    { name: 'rotateY', value: Math.PI / 6 },
    { name: 'rotateZ', value: Math.PI / 2 + 0.2 },
  ]
};

export default constelsIconArgs;
